// src/components/Hero.jsx
import React, { useState, useEffect, useRef } from 'react';
import '../styles/Hero.css';

import img1 from '../Assets/Images/atml1.jpg';
import img2 from '../Assets/Images/atml2.jpg';
import img3 from '../Assets/Images/atml3.jpg';

const slides = [
  {
    img: img1,
    title: "Akij Textile Mills Ltd.",
    subtitle: "Weaving Quality with Innovation",
  },
  {
    img: img2,
    title: "Akij Textile Mills Ltd.",
    subtitle: "Weaving Quality with Innovation",
  },
  {
    img: img3,
    title: "Akij Textile Mills Ltd.",
    subtitle: "Weaving Quality with Innovation",
  },
];

function AtmlHero() {
  const [current, setCurrent] = useState(0);
  const slidesLength = useRef(slides.length);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent(prev => (prev + 1) % slidesLength.current);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const goToNext = () => setCurrent((current + 1) % slidesLength.current);
  const goToPrev = () => setCurrent((current - 1 + slidesLength.current) % slidesLength.current);

  return (
    <section className="hero-section">
      <div className="slider-wrapper">
        {slides.map((slide, index) => (
          <div
            key={index}
            className={`slide ${index === current ? 'active' : ''}`}
            style={{ backgroundImage: `url(${slide.img})` }}
          >
            <div className="hero-overlay">
              <div className="hero-content">
                <h1 className="hero-title">{slide.title}</h1>
                <p className="hero-subtitle">{slide.subtitle}</p>
                <a href="https://www.akijtextile.com/" className="hero-button" target="_blank" rel="noopener noreferrer">Learn More</a>
              </div>
            </div>
          </div>
        ))}

        {/* <button className="prev-btn" onClick={goToPrev}>&#10094;</button> */}
        {/* <button className="next-btn" onClick={goToNext}>&#10095;</button> */}
        <div className="hero-nav-buttons">
          <button onClick={goToPrev}>&larr;</button>
          <button onClick={goToNext}>&rarr;</button>
        </div>

      </div>
    </section>
  );
}

export default AtmlHero;
